module.exports = __webpack_public_path__ + "img/exam-report-header.ba55157b.png";